<script>
    import Header from "../header.svelte"
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";

    let is_busy = false;
    let content_title = "Settings - Email"

    let cc_email = "";

    let new_signup_email_template = "";
    let new_crew_invite_email_template = "";
    let new_lead_prospect_email_template = "";
    let new_lead_customer_email_template = "";
    let new_booking_customer_email_template = "";
    let new_booking_client_email_template = "";
    let new_service_reminder_client_email_template = "";
    let new_service_thank_you_email_template = "";
    let new_contractor_invoice_email_template = "";
    let new_crew_service_reminder_email_template = "";

</script>

<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">



    <div class="section">
        <div class="sectionsubtitle">Reply-To Email</div>
        <div class="noticeholder">
            Note: all emails are sent from service@houseofyards.com, however you can set your own email address below which will recieve a CC of the email and which will be the reply-to email address when the recipent responds to th email.
        </div>
    
        <IFTAInput 
        type="text"
        label="Email Address"
        placeholder="the_boss@my_lawn_services.com" 
        bind:value={cc_email}
        helper_text="Reply-To and CC email address"
        />        
    </div>

    

    <div class="section">
        <div class="sectionsubtitle">Email Templates</div>

        <IFTAInput 
        type="textarea"
        label="New Signup Email Template"
        bind:value={new_signup_email_template}
        helper_text="Email template sent for new sign-ups."
        />        

        <IFTAInput 
        type="textarea"
        label="New Crew Invite Email Template"
        bind:value={new_crew_invite_email_template}
        helper_text="Email template sent for new crew invitations."
        />        

        <IFTAInput 
        type="textarea"
        label="New Lead Email To Prospect Template"
        bind:value={new_lead_prospect_email_template}
        helper_text="Lead email template sent to the prospect."
        />        

        <IFTAInput 
        type="textarea"
        label="New Lead Email To Customer Template"
        bind:value={new_lead_customer_email_template}
        helper_text="Lead email template sent to the customer."
        />        

        <IFTAInput 
        type="textarea"
        label="New Booking Email Template - Customer"
        bind:value={new_booking_customer_email_template}
        helper_text="Booking email template sent to the customer."
        />        

        <IFTAInput 
        type="textarea"
        label="New Booking Email Template - Client"
        bind:value={new_booking_client_email_template}
        helper_text="Booking email template sent to the client."
        />        

        <IFTAInput 
        type="textarea"
        label="Client Job Reminder Email Template"
        bind:value={new_service_reminder_client_email_template}
        helper_text="Job reminder email template sent to the client."
        />        

        <IFTAInput 
        type="textarea"
        label="After Job Thank You Email Template"
        bind:value={new_service_thank_you_email_template}
        helper_text="Post-job thank-you email sent to the client."
        />        

        <IFTAInput 
        type="textarea"
        label="Contractor Invoice Email Template"
        bind:value={new_contractor_invoice_email_template}
        helper_text="Email template sent when contractors invoice."
        />        

        <IFTAInput 
        type="textarea"
        label="Crew Job Reminder Email Template"
        bind:value={new_crew_service_reminder_email_template}
        helper_text="Email template sent to remind crew of job.."
        />        

    </div>

    <div class="buttonholder">
        <button class="savebutton" on:click={() => {console.log("hello");}} ><i class="far fa-save"></i> Save Settings</button>
    </div>
    
</div>


<style>
    .contentholder {
        padding: 0px;
        width: 100%;
    }

    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        /* background-color: #357a38; */
        /* color: white; */
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }

    .noticeholder {
        width: 100%;
        margin-top: 25px;
        font-size: 1rem;
        font-style: italic;
        color: #666;
    }

    .section_old {
        width: 100%;
    }

    .section_old .sectionsubtitle_old {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
        color: white;
        background-color: #1769aa;
        padding: 5px;
        box-sizing: border-box;
    }
    .section {
        border: 1px solid #1769aa;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        .section_old {
            padding: 0px;
        }

    }

</style>